/**
 * LA TARDANZA QUE CUENTA EN LA AUDITORIA DE ASISTENCIA (IND-TARDANZA-UNA-T1, A #20695).
 *
 * Una sola tardanza: la del detector de la base. Hasta el 1-oct Brayan tenia 23, 20 o 2 tardanzas en septiembre segun
 * quien contara; desde el nexo-api 383, GET asistencia/auditoria trae por dia `clasificacion` (OK | TARDANZA |
 * POSIBLE_INTERCAMBIO | FUERA_DE_RANGO | DIA_INCOMPLETO | ...) y `tardanzaOficialMin` (null si el dia no es TARDANZA).
 * Con esos campos el panel NO decide: cuenta lo que la base clasifico.
 *
 * SIN ellos (API anterior al 383) queda la regla de antes (VIS-T1 #3750, gate #3769): gracia de 5 minutos y un desvio de
 * 60 o mas no es tardanza sino otro turno. `tardanzaEntradaMin` sigue siendo el desvio crudo, la MEDIDA, nunca la
 * tardanza.
 *
 * Puro: lo prueba scripts/check-tardanza-oficial.mjs.
 *
 * @module domain/tardanzaAuditoria
 */

export const GRACIA_MIN = 5;          // asistencia.tarde_rango filtra > 5 (verificado en #3753)
export const TURNO_DUDOSO_MIN = 60;   // decision (a) de #3750: a partir de aca no es tardanza, es otro turno

/** Las clasificaciones de la base que dicen "horario distinto al programado": se revisan aparte, no son tardanza. */
export const CLASIFICACIONES_DUDOSAS = Object.freeze(['POSIBLE_INTERCAMBIO', 'FUERA_DE_RANGO']);

/** ¿Este dia trae la clasificacion de la base? */
export function traeClasificacion(item) {
  return typeof item?.clasificacion === 'string' && item.clasificacion.length > 0;
}

/** Minutos de tardanza que SI cuentan. Con la base: solo los dias TARDANZA, con su minuto oficial. */
export function tardanzaReal(item) {
  if (traeClasificacion(item)) {
    return item.clasificacion === 'TARDANZA' ? Math.max(0, Number(item.tardanzaOficialMin) || 0) : 0;
  }
  const t = Number(item?.tardanzaEntradaMin) || 0;
  if (t <= GRACIA_MIN) return 0;
  if (t >= TURNO_DUDOSO_MIN) return 0;
  return t;
}

/** El dia no se midio contra el turno que la persona realmente trabajo. */
export function esTurnoDudoso(item) {
  if (traeClasificacion(item)) return CLASIFICACIONES_DUDOSAS.includes(item.clasificacion);
  return (Number(item?.tardanzaEntradaMin) || 0) >= TURNO_DUDOSO_MIN;
}
